import type {QueryClient} from '@tanstack/react-query'

import {paginatedMemexItemsQueryKey, subIssuesQueryKey} from '../queries/query-keys'

export function getPaginatedQueryKeyWithVariables(queryClient: QueryClient) {
  const keyWithoutVariables = ['memex', paginatedMemexItemsQueryKey]
  const queryCache = queryClient.getQueryCache()
  const firstActiveQuery = queryCache.find({
    queryKey: keyWithoutVariables,
    exact: false,
    type: 'active',
  })
  if (!firstActiveQuery) {
    // We should not be in this state when normally interacting
    // with the query-client-api, however for tests, we don't always have an active query.
    return keyWithoutVariables
  }
  // We only want to return the first three elements of the query key, which are the
  // memex prefix, primary query key, and the variables. We don't want to include the groupId or the pageParam
  return firstActiveQuery.queryKey.slice(0, 3)
}

export function getSubIssuesQueryKeyWithVariables(queryClient: QueryClient) {
  const keyWithoutVariables = ['memex', subIssuesQueryKey]
  const queryCache = queryClient.getQueryCache()
  const firstActiveQuery = queryCache.find({
    queryKey: keyWithoutVariables,
    exact: false,
    type: 'active',
  })
  if (!firstActiveQuery) {
    return keyWithoutVariables
  }
  // We only want to return the first three elements of the query key, which are the
  // memex prefix, primary query key, and the variables.
  return firstActiveQuery.queryKey.slice(0, 3)
}
